import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import styles from './AppNav.module.css';

const icons = {
  today:
    'M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4M12 8a4 4 0 1 0 0 8a4 4 0 1 0 0-8',
  learn: 'M4 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4zM8 3h12v13M8 13l2 2l4-4',
  decks: 'M3 7l9-4l9 4l-9 4zM3 12l9 4l9-4M3 17l9 4l9-4',
  profile: 'M12 12a4 4 0 1 0 0-8a4 4 0 1 0 0 8M4 21a8 8 0 0 1 16 0',
} as const;

const tabs: { key: keyof typeof icons; to: string; end?: boolean }[] = [
  { key: 'today', to: '/', end: true },
  { key: 'learn', to: '/review' },
  { key: 'decks', to: '/decks' },
  { key: 'profile', to: '/settings' },
];

/**
 * The four sections of the application. A bar along the bottom edge on a
 * phone, where the thumb reaches it, and a row in the header on a wide screen.
 */
export function AppNav(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <nav className={styles.nav} aria-label={t('nav.label')}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.key}
          to={tab.to}
          end={tab.end ?? false}
          className={({ isActive }) => [styles.tab, isActive ? styles.active : ''].join(' ')}
        >
          <svg
            className={styles.icon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d={icons[tab.key]} />
          </svg>
          <span>{t(`nav.${tab.key}`)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
